import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { Times } from '@styled-icons/fa-solid/Times';
import { UserPlus } from '@styled-icons/fa-solid/UserPlus';
import { device } from '../../constants/device-sizes';
import ModalButton from './ModalButton';
import TitleText from './TitleText';

const CloseButton = styled(Times)`
  cursor: pointer;
  position: absolute;
  width: 2.5rem;
  height: 2.5rem;
  top: 1rem;
  right: 1rem;
  margin: 1rem 1rem;
  font-size: 2rem;
  transition: all 0.2s linear;
  color: var(--clr-sec);
  :hover {
    color: red;
  }
`;

const ModalWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  @media ${device.tablet} {
    width: 50%;
    position: auto;
    top: auto;
  }
  top: 0px;
  position: absolute;
`;

const ModalContent = styled.div`
  padding: 16px;
  background-color: var(--clr-bg);
  width: 100%;
  border-radius: 12px;
  shadow-opacity: 0.18;
  shadow-radius: 4px;
  shadow-color: #000;
  shadow-offset: 0px 4px;
  elevation: 10;
`;

const Description = styled.p`
  color: var(--clr-sec);
  font-size: 16px;
  text-align: center;
  margin: 1.5rem 0;
  line-height: 1.5;
`;

const FeatureList = styled.ul`
  color: var(--clr-sec);
  font-size: 14px;
  margin: 1.5rem 0;
  padding-left: 1.5rem;

  li {
    margin-bottom: 0.5rem;
    line-height: 1.4;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

const ModalButtonSC = styled.div`
  cursor: pointer;
  flex-grow: 1;
  margin: 0 0.5rem;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  color: var(--clr-green);
`;

const AccountRequiredModal = ({
  visible,
  onClose,
  onCreateAccount,
  context = 'friends',
}) => {
  const getTitle = () => {
    return 'Account Number Required';
  };

  const getDescription = () => {
    switch (context) {
      case 'send_request':
        return "To send friend requests, you need a VentScape account number. This ensures you won't lose your friends list if you change browsers or devices.";
      case 'accept_request':
        return "To accept friend requests, you need a VentScape account number. This ensures you won't lose your friends list if you change browsers or devices.";
      default:
        return 'You need a VentScape account to use this feature.';
    }
  };

  return (
    <Modal
      isOpen={visible}
      onRequestClose={onClose}
      style={{
        overlay: { zIndex: 1000, backgroundColor: 'rgba(0,0,0,0.5)' },
        content: {
          background: 'none',
          border: 'none',
          padding: 0,
          inset: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
      ariaHideApp={false}
    >
      <ModalWrapper>
        <ModalContent>
          <CloseButton onClick={onClose} />

          <TitleText>{getTitle()}</TitleText>

          <IconContainer>
            <UserPlus size={48} />
          </IconContainer>

          <Description>{getDescription()}</Description>

          <FeatureList>
            <li>Keep your friends list across devices</li>
            <li>Never lose your connections</li>
            <li>Secure account with unique ID</li>
            <li>Free and takes less than 30 seconds</li>
          </FeatureList>

          <ButtonContainer>
            <ModalButtonSC
              width='45%'
              as={ModalButton}
              isAffirmative={false}
              onClick={onClose}
            >
              Cancel
            </ModalButtonSC>
            <ModalButtonSC
              width='45%'
              as={ModalButton}
              isAffirmative={true}
              onClick={onCreateAccount}
            >
              Create Account
            </ModalButtonSC>
          </ButtonContainer>
        </ModalContent>
      </ModalWrapper>
    </Modal>
  );
};

export default AccountRequiredModal;
